// src/components/StatusBanner.jsx
// A short notice at the bottom of the screen: the connection is gone (the app itself still opens, but nothing
// can be saved), or a new version of the app is ready.
import React, { useEffect, useState } from 'react';
import { applyUpdate, subscribeToUpdates } from '../serviceWorkerRegistration';
import { useSync } from '../sync/SyncProvider';

// What being offline means depends on how this device is set up.
export function offlineMessage({ isGuest, enabled, signedIn }) {
    if (isGuest) return null; // everything is on the device anyway: nothing to warn about
    if (enabled) return 'You are offline. Your changes are saved on this device and sent to the server once you are back online.';
    if (signedIn) {
        return 'You are offline, and this device has not prepared itself for offline use yet (that happens by itself the next time you are online). You can look around, but changes cannot be saved until the connection is back.';
    }
    return 'You are offline. You can look around, but nothing can be saved until the connection is back.';
}

function StatusBanner() {
    const [online, setOnline] = useState(typeof navigator === 'undefined' ? true : navigator.onLine !== false);
    const [updateReady, setUpdateReady] = useState(false);
    const message = offlineMessage(useSync() || {});

    useEffect(() => {
        const goOnline = () => setOnline(true);
        const goOffline = () => setOnline(false);
        window.addEventListener('online', goOnline);
        window.addEventListener('offline', goOffline);
        return () => {
            window.removeEventListener('online', goOnline);
            window.removeEventListener('offline', goOffline);
        };
    }, []);

    useEffect(() => subscribeToUpdates((worker) => setUpdateReady(Boolean(worker))), []);

    const showOffline = !online && message;
    if (!showOffline && !updateReady) return null;
    return (
        <div className="status-banner" role="status">
            {showOffline && <p>{message}</p>}
            {updateReady && (
                <p>
                    A new version of Tournamental is ready.{' '}
                    <button className="btn btn-sm btn-primary" onClick={applyUpdate}>
                        Reload
                    </button>
                </p>
            )}
        </div>
    );
}

export default StatusBanner;
